import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        answers: [],
        avatar: '',
        weight: 3,
        sex: '',

        //nb of pts
        total: 0,
        resultsUrl:'',

    },
    mutations: {
        setAnswers(state, payload) {
            state.answers = payload.answers;
        },
        setTotal(state, payload) {
            state.total = payload.total;
        },
        setResultsUrl(state, payload) {
            state.resultsUrl = payload.resultsUrl;
        },
        updateField,
    },
    getters: {
        getField,

        getAnswers: state => {
            return state.answers
        },
        getTotal: state => {
            return state.total
        },
        

    }
});


// WEBPACK FOOTER //
// ./src/common/Store.js